<template>
  <div>
    <section-title
      content="Datos sobre acceso a la AT en la Escuela"
      :has-line="false"
      icon="far fa-info-circle"
      bgIcon="bg-white"
      containerClass="tag-badge-info-custom"
    />
    <div class="px-3">
      <div class="row">
        <div
          v-for="(item, key) in questions"
          :key="key"
          class="col-12 col-lg-6"
        >
          <div class="col my-3 border-bottom pr-1">
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="row mb-3 mb-md-0">
                <div class="col-7 d-flex align-items-center">
                  {{ item.text }}
                </div>
                <div class="col d-flex justify-content-end pr-0">
                  <custom-radio
                    is-question-list
                    class="radio-button-container"
                    v-model="item.answer"
                    :key="item.answer"
                    :options="yesNoOptions(item)"
                    :disabled="isReadOnly"
                    :customErrorMsg="''"
                    @input="onQuestionChange($event, item)"
                  />
                </div>
                <div class="col-12" v-if="Boolean(errors[0])">
                  <Error
                    variant="no-border"
                    message="Favor de seleccionar una opción."
                  />
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Especifique otros equipos en la escuela a los que tiene acceso el
              estudiante:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.otherEquipmentSchool"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Observaciones adicionales:
            </label>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.additionalRemarks"
              class="mb-2"
              :count-classes="['d-block text-right']"
              custom-error-msg="Este campo es requerido"
              :error="errors[0] ? 'err' : ''"
              :maxlength="3000"
              :show-char-count="true"
              placeholder="Comentario"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomRadio from '@/components/common/CustomRadioBorder';
import Error from '@/components/common/Error.vue';
import CustomTextArea from '@quisit/custom-text-area';
export default {
  name: 'DataAccessATSchool',
  components: {
    SectionTitle,
    CustomRadio,
    Error,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    yesNoOptions() {
      return (question) => {
        const { answer, answers, id } = question;

        const answersSaved = this.model.questions.find(
          (x) => x.questionId === id
        );

        if (answersSaved) {
          return [
            {
              label: 'SI',
              value: true,
              check: answersSaved.answerId === answers[0].id,
              model: answers[0],
            },
            {
              label: 'NO',
              value: false,
              check: answersSaved.answerId === answers[1].id,
              model: answers[1],
            },
          ];
        }

        return [
          {
            label: 'SI',
            value: true,
            check: answer === true,
            model: answers[0],
          },
          {
            label: 'NO',
            value: false,
            check: answer === false,
            model: answers[1],
          },
        ];
      };
    },
  },
  methods: {
    onQuestionChange(value, question) {
      const { model } = this.yesNoOptions(question).find(
        (item) => item.value === value
      );
      this.$forceUpdate();

      if (!model) return;

      const index = this.model.questions.findIndex(
        (item) => item.questionId === question.id
      );

      if (index !== -1) {
        this.model.questions[index].answerId = model.id;
        this.model.questions[index].answer = value;
        return;
      }

      this.model.questions.push({
        questionId: question.id,
        answerId: model.id,
        answer: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .title-icon {
  color: #ff7058 !important;
  font-size: 1.3rem !important;
  margin: 3.6px !important;
}

::v-deep .tag-badge-info-custom {
  background: linear-gradient(90deg, #fff0e1 24.8%, #ffffff 82%) !important;
}
</style>
